// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"5c48a93c","839":"ab59483d"}[chunkId] + ".chunk.js";
};